import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';

// Unmatched URLs used to render the home page shell with a 200, which presented
// every typo as a duplicate homepage. Vercel's Create React App preset owns the
// catch-all route and cannot be overridden from vercel.json without dropping the
// framework preset, so this handles it in the router instead: still a soft 404 to
// Google, but the page says so and carries noindex.
export const NotFoundPage = () => {
  const path =
    typeof window !== 'undefined' ? window.location.pathname : '';

  return (
    <main
      id="main-content"
      tabIndex={-1}
      data-testid="not-found-page"
      className="min-h-screen bg-[#0D0D0D] flex items-center justify-center px-6 py-32"
    >
      <SEO
        title="Page Not Found"
        description="That page does not exist. Browse our event production services or get in touch with New Creative Industries in Pretoria."
        path={path}
        noIndex
      />

      <div className="text-center max-w-xl">
        <p className="text-xs uppercase tracking-[0.3em] text-[#47debd] font-bold mb-4">
          Error 404
        </p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-tight text-white mb-6">
          That page does not exist
        </h1>
        <p className="text-base sm:text-lg text-[#A3A3A3] leading-relaxed mb-10">
          The link may be out of date, or the address may have a typo in it.
          Everything we do is a click away below.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            data-testid="notfound-link-home"
            className="inline-flex items-center justify-center px-8 py-4 text-sm font-bold uppercase tracking-widest text-white bg-[#17798A] hover:bg-[#12626F] transition-all duration-300 rounded-lg"
          >
            Back to Home
          </Link>
          <Link
            to="/services"
            data-testid="notfound-link-services"
            className="inline-flex items-center justify-center px-8 py-4 text-sm font-bold uppercase tracking-widest text-white border border-white/30 hover:border-[#47c3d6] hover:text-[#47c3d6] transition-all duration-300 rounded-lg"
          >
            Our Services
          </Link>
        </div>
      </div>
    </main>
  );
};
